import * as cookie from 'cookie';
import { Location } from 'history';
import { LOGIN_TITLE, SIGNUP_TITLE } from 'mk/autogenerated/translations/utils.362b1bed39a4b7511501ceccc108b3f8'
import { logout_url } from 'mk/urls/functions';
import { loginUrl, signupUrl } from 'mk2/apps/users/urls';
import Btn, { BtnType } from 'mk2/components/Btn';
import { parse } from 'query-string';
import React from 'react';

export function getLastKnownUsernameCookie(): string {
    return cookie.parse(document.cookie)._remember || null;
}

export function storeLastKnownUsernameCookie(username: string) {
    document.cookie = cookie.serialize('_remember', username, {
        path: '/',
        maxAge: 400 * 24 * 60 * 60,  // 400 days
    });
}

export function getPregnancyNewsletterCookie(): boolean {
    return Boolean(cookie.parse(document.cookie).pregnancyNewsletterSubscribed);
}

export function storeNewsletterClosedCookie() {
    document.cookie = cookie.serialize('pregnancy_newsletter_closed', 'true', {
        path: '/',
        maxAge: 30 * 24 * 60 * 60,  // 30 days
    });
}

export function getPregnancyNewsletterClosedCookie(): boolean {
    return Boolean(cookie.parse(document.cookie).pregnancy_newsletter_closed);
}

export function getNewGroupsCookie(): boolean {
    return cookie.parse(document.cookie).new_groups === '1';
}

function isUnsuitableRedirectUrl(url: string): boolean {
    return url.startsWith(logout_url())
        || url.indexOf(loginUrl) >= 0
        || url.indexOf('://') >= 0
        || url.indexOf(' ') >= 0;
}

export function gotoUrlAfterLoginOrSignup(baseUrl: string, location: Location, defaultUrl: string): string {
    let redirectTo = parse(location.search).next;
    redirectTo = (!redirectTo || isUnsuitableRedirectUrl(redirectTo))
        ? null
        : baseUrl + redirectTo; // FIXME az bude cela app v react, netreba absolut url a bude fungovat success toast

    if (!redirectTo) {
        redirectTo = baseUrl + defaultUrl;  // iframe can be embedded in other pages than www.modrykonik.sk, so we need to use absolute url
    }
    return redirectTo;
}

export function loginSignupTabs(active: string) {
    return [(
        <Btn
            key="signup"
            type={BtnType.Tab}
            label={SIGNUP_TITLE}
            link={signupUrl}
            active={active === 'signup'}
        />), (
        <Btn
            key="login"
            type={BtnType.Tab}
            label={LOGIN_TITLE}
            link={loginUrl}
            active={active === 'login'}
        />)];
}

export function cleanPhoneNumber(prefix, phoneNumber) {
    if (prefix === '+421' || prefix === '+420') {
        return phoneNumber.replace(/\s+/g, '').slice(-9);
    }
    return phoneNumber;
}
